import Blue from "~/core";

new Blue({
	name: 'Scrollable Table',
	selector: "table.table",
	setup(table) {
    let tableWidth = table.offsetWidth;
		const parent = table.parentElement;
		let parentWidth = parent.offsetWidth;
		let needsScrollable = tableWidth > parentWidth;
		let scrollingContainer;
		let tableWrapper;
		let topTools;
		let bottomTools;
		let toolElements;

		const createScrollingTools = () => {
			const scrollingTools = document.createElement("div");
			scrollingTools.classList.add("table-scrolling__tools");

			const leftBtn = document.createElement("button");
			leftBtn.classList.add("table-scrolling__btn");
			leftBtn.classList.add("table-scrolling__btn--left");
			leftBtn.setAttribute("aria-label", "Scroll table left");

			const rightBtn = document.createElement("button");
			rightBtn.classList.add("table-scrolling__btn");
			rightBtn.classList.add("table-scrolling__btn--right");
			rightBtn.setAttribute("aria-label", "Scroll table right");

			const scrollbar = document.createElement("div");
			scrollbar.classList.add("table-scrolling__bar");
			const scrollbarIndicator = document.createElement("div");
			scrollbarIndicator.classList.add("table-scrolling__indicator");

			scrollbar.appendChild(scrollbarIndicator);
			scrollingTools.appendChild(leftBtn);
			scrollingTools.appendChild(rightBtn);
			scrollingTools.appendChild(scrollbar);

			return scrollingTools;
		}

		// Use this to set the scrollbar's indicator width based on the table's width
		const styleScrollbarIndicator = toolEl => {
			const scrollbar = toolEl.querySelector(".table-scrolling__bar");
			const scrollbarIndicator = toolEl.querySelector(".table-scrolling__indicator");
			const tableWidth = table.offsetWidth;
			const parentWidth = tableWrapper.offsetWidth;
			const scrollbarWidth = scrollbar.offsetWidth;
			const scrollbarIndicatorWidth = (parentWidth / tableWidth) * scrollbarWidth;
			scrollbarIndicator.style.width = `${scrollbarIndicatorWidth}px`;
		}

		function detectScrollAndSetStyles() {
			if (!!scrollingContainer == false) return;
			const leftBtns = [...scrollingContainer.querySelectorAll(".table-scrolling__btn--left")];
			const rightBtns = [...scrollingContainer.querySelectorAll(".table-scrolling__btn--right")];
			if (tableWrapper.scrollLeft === 0) {
				// disabled both left btns
				leftBtns.forEach(btn => btn.disabled = true);
				tableWrapper.classList.remove("scrollable-to-left");
			} else {
				leftBtns.forEach(btn => btn.disabled = false);
				tableWrapper.classList.add("scrollable-to-left");
			}
			if (tableWrapper.scrollLeft >= tableWidth - parentWidth - 1) {
				// disabled both right btns
				rightBtns.forEach(btn => btn.disabled = true);
				tableWrapper.classList.remove("scrollable-to-right");
			} else {
				rightBtns.forEach(btn => btn.disabled = false);
				tableWrapper.classList.add("scrollable-to-right");
			}
		}
		const addEventListenersForTools = (left, right, bar, isResize) => {
			const tool = left.closest(".table-scrolling__tools");
			if (isResize) {
				// remove event listeners by cloning and replacing the elements passed in as arguments
				const oldLeft = left;
				left = oldLeft.cloneNode(true);
				oldLeft.replaceWith(left);
				const oldRight = right;
				right = oldRight.cloneNode(true);
				oldRight.replaceWith(right);
				const oldBar = bar;
				bar = oldBar.cloneNode(true);
				oldBar.replaceWith(bar);
				styleScrollbarIndicator(tool);
			}
			
			const scrollbarIndicator = bar.querySelector(".table-scrolling__indicator");
			tableWidth = table.offsetWidth;
			parentWidth = tableWrapper.offsetWidth;
			let scrollbarWidth = bar.offsetWidth;
			let scrollbarIndicatorWidth = (parentWidth / tableWidth) * scrollbarWidth;
			scrollbarIndicator.style.width = `${scrollbarIndicatorWidth}px`;

			const bothIndicators = [...scrollingContainer.querySelectorAll(".table-scrolling__indicator")];
			const otherIndicator = bothIndicators.find(indicator => indicator !== scrollbarIndicator);

			function handleBtnClick() {
				const direction = this.matches(".table-scrolling__btn--left") ? "left" : "right";
				if (direction === "left") {
					tableWrapper.scrollLeft -= 50;
				} else if (direction === "right") {
					tableWrapper.scrollLeft += 50;
				}
				scrollbarWidth = bar.offsetWidth;
				scrollbarIndicatorWidth = (parentWidth / tableWidth) * scrollbarWidth;
				let ratioOfScroll = tableWrapper.scrollLeft / (tableWrapper.scrollWidth - tableWrapper.clientWidth);
				scrollbarIndicator.style.left = `${(scrollbarWidth - scrollbarIndicatorWidth) * ratioOfScroll}px`;
				otherIndicator.style.left = `${(scrollbarWidth - scrollbarIndicatorWidth) * ratioOfScroll}px`;
				detectScrollAndSetStyles();
			}
				

			left.addEventListener("click", handleBtnClick);

			right.addEventListener("click", handleBtnClick);

			let isMouseDown = false;

			function handleMouseDown(e) {
				isMouseDown = true;
				
				const initialX = e.clientX - scrollbarIndicator.getBoundingClientRect().left;

				// Move the BOTH indicators (top and bottom) based on the mouse position
				function moveIndicators(e) {
					if (!isMouseDown) return;
					const newScrollLeft = e.clientX - initialX - bar.getBoundingClientRect().left;
					const maxScroll = scrollbarWidth - scrollbarIndicatorWidth;
					if (newScrollLeft >= 0 && newScrollLeft <= maxScroll) {
						scrollbarIndicator.style.left = `${newScrollLeft}px`;
						otherIndicator.style.left = `${newScrollLeft}px`;
						const scrollPercentage = newScrollLeft / maxScroll;
						tableWrapper.scrollLeft = scrollPercentage * (tableWidth - parentWidth);
						detectScrollAndSetStyles();
					} else if (newScrollLeft < 0) {
						scrollbarIndicator.style.left = "0";
						otherIndicator.style.left = "0";
						tableWrapper.scrollLeft = 0;
						detectScrollAndSetStyles();
					} else if (newScrollLeft > maxScroll) {
						scrollbarIndicator.style.left = `${maxScroll}px`;
						otherIndicator.style.left = `${maxScroll}px`;
						tableWrapper.scrollLeft = tableWidth - parentWidth;
						detectScrollAndSetStyles();
					}
				}

				// Using pointer events instead of mouse events to keep it working well for both mobile and desktop
				document.addEventListener("pointermove", moveIndicators, true);
				document.addEventListener("pointerup", () => {
					isMouseDown = false;
					document.removeEventListener("pointermove", moveIndicators, true);
				});
			}

			bar.addEventListener("pointerdown", handleMouseDown);

		}

		const initScrollability = (isResize) => {
			if (isResize && !!scrollingContainer) {
				scrollingContainer = table.closest(".table-scrolling");
				tableWrapper = scrollingContainer?.querySelector(".table-scrolling__wrapper");
				topTools = scrollingContainer?.querySelector(".table-scrolling__tools:first-child");
				bottomTools = scrollingContainer?.querySelector(".table-scrolling__tools:last-child");
				if (!!tableWrapper) tableWrapper.scrollLeft = 0;
				toolElements.forEach((tool) => {
					const scrollbar = tool.querySelector(".table-scrolling__bar");
					const indicator = scrollbar.querySelector(".table-scrolling__indicator");
					indicator.style.left = "0";
				});
			} else {
				scrollingContainer = document.createElement("div");
				scrollingContainer.classList.add("table-scrolling");
				tableWrapper = document.createElement("div");
				tableWrapper.classList.add("table-scrolling__wrapper");
				table.parentElement.insertBefore(scrollingContainer, table);
				topTools = createScrollingTools();
				bottomTools = createScrollingTools();
				scrollingContainer.insertAdjacentElement("afterbegin", topTools);
				scrollingContainer.appendChild(tableWrapper);
				scrollingContainer.insertAdjacentElement("beforeend", bottomTools);
				tableWrapper.appendChild(table);
			}
			toolElements = !!scrollingContainer ? [...scrollingContainer?.querySelectorAll(".table-scrolling__tools")] : [];
			toolElements.forEach((tool) => {
				const leftBtn = tool.querySelector(".table-scrolling__tools .table-scrolling__btn--left");
				const rightBtn = tool.querySelector(".table-scrolling__tools .table-scrolling__btn--right");
				const scrollbar = tool.querySelector(".table-scrolling__tools .table-scrolling__bar");
				addEventListenersForTools(leftBtn, rightBtn, scrollbar, isResize);
			});
			tableWrapper?.classList.add("scrollable-to-right");
			tableWrapper?.addEventListener("scroll", handleWrapperScroll);
		}

		const destroyScrollability = () => {
			if (!!tableWrapper) {
				scrollingContainer.replaceWith(table);
			}
		}

		const testNeedsScrollable = (isResize) => {
			tableWidth = table.offsetWidth;
			parentWidth = parent.offsetWidth;
			needsScrollable = tableWidth > parentWidth;
			if (needsScrollable) {
				initScrollability(isResize);
			} else {
				destroyScrollability();
			}
		};

		testNeedsScrollable();
		detectScrollAndSetStyles();

		let resizeTimer;
		const throttleResizeFunc = () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => testNeedsScrollable(true), 5);
		}

		window.addEventListener("resize", () => throttleResizeFunc());

		// Handle when user manually scrolls the table i.e. with a mousewheel
		function handleWrapperScroll() {
			const tableWidth = table.offsetWidth;
			const parentWidth = tableWrapper.offsetWidth;
			const ratioOfScroll = tableWrapper.scrollLeft / (tableWidth - parentWidth);
			const scrollbarWidth = topTools.querySelector(".table-scrolling__bar").offsetWidth;
			const scrollbarIndicatorWidth = (parentWidth / tableWidth) * scrollbarWidth;
			const leftIndicator = topTools.querySelector(".table-scrolling__indicator");
			const rightIndicator = bottomTools.querySelector(".table-scrolling__indicator");
			leftIndicator.style.width = `${scrollbarIndicatorWidth}px`;
			rightIndicator.style.width = `${scrollbarIndicatorWidth}px`;
			leftIndicator.style.left = `${(scrollbarWidth - scrollbarIndicatorWidth) * ratioOfScroll}px`;
			rightIndicator.style.left = `${(scrollbarWidth - scrollbarIndicatorWidth) * ratioOfScroll}px`;
			detectScrollAndSetStyles();
		}

	}
});